import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsBarcodeManagementBarcodeStatusDataParmInfo } from "./wsBarcodeManagementBarcodeStatusDataParmInfo";
import { wsBarcodeManagementCardStatusUpdateParm } from "./wsBarcodeManagementCardStatusUpdateParm";

@Injectable()
export class DataService_barcode {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	BarcodeManagementBarcodeSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	BarcodeManagementBarcodeSelectList(PersonID: number) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/BarcodeManagementBarcodeSelectList";

		var promise$ = this.httpclientService.post(url, PersonID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	BarcodeManagementStatusDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	BarcodeManagementStatusDataGet(parms: wsBarcodeManagementBarcodeStatusDataParmInfo) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/BarcodeManagementStatusDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	BarcodeManagementMTAStatusDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	BarcodeManagementMTAStatusDataGet(parms: wsBarcodeManagementBarcodeStatusDataParmInfo) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/BarcodeManagementMTAStatusDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	BarcodeManagementCardStatusUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	BarcodeManagementCardStatusUpdate(parms: wsBarcodeManagementCardStatusUpdateParm) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/BarcodeManagementCardStatusUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PublicTransitPreferenceSelect
	//
	//-----------------------------------------------------------------------------------------------------
	PublicTransitPreferenceSelect() {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/PublicTransitPreferenceSelect";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
